import '@descope-ui/descope-enriched-text';
import '@vaadin/tooltip';
import { componentName, TooltipClass } from './TooltipClass';

customElements.define(componentName, TooltipClass);

export { TooltipClass, componentName };
